<template>
  <div>
    <div class="card-container">
      <a-tabs type="card">
        <a-tab-pane key="1" tab="校园动态">
          
          <router-link
            :to="{
              path: '/newsDetail',
              query: { classId: '49030609377332', classCName: '校园动态' },
            }"
            class="btn"
            tag="div"
          >
            更多
            <a-icon type="right" />
          </router-link>
          <div v-for="(item, index) in scList" :key="index">
            <a v-if="item.urlAddress && item.urlAddress!=''" :href="item.urlAddress" tag="div"
      class="contNews_title">
      <div
              class="contentImg"
              v-show="
                item.picUrl == null || item.picUrl == ''
                  ? (isImg = false)
                  : (isImg = true)
              "
            >
              <img :src="item.picUrl" alt />
            </div>
            <div>
              <div>{{ item.newsTitle }}</div>
              <div>{{ item.sNewsTitle }}</div>
            </div>
      </a>
            <router-link v-else
            class="contNews_title"
            :to="{
              path: '/scNewsDetail',
              query: {
                newsId: item.newsId,
                newsTitle: item.newsTitle,
                source: item.source,
                createBy: item.createBy,
                newsTitle: item.newsTitle,
                urlAddress: item.urlAddress,
              },
            }"
            tag="div"
            
          >
            <div
              class="contentImg"
              v-show="
                item.picUrl == null || item.picUrl == ''
                  ? (isImg = false)
                  : (isImg = true)
              "
            >
              <img :src="item.picUrl" alt />
            </div>
            <div>
              <div>{{ item.newsTitle }}</div>
              <div>{{ item.sNewsTitle }}</div>
            </div>
          </router-link>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="教育动态">
          <router-link
            :to="{
              path: '/newsDetail',
              query: { classId: '20190085265419', classCName: '教育动态' },
            }"
            class="btn"
            tag="div"
          >
            更多
            <a-icon type="right" />
          </router-link>
          <div v-for="(item, index) in teList"
            :key="index">
            <a v-if="item.urlAddress && item.urlAddress!=''" :href="item.urlAddress" tag="div"
      class="contNews_title">
      <div
              class="contentImg"
              v-show="
                item.picUrl == null || item.picUrl == ''
                  ? (isImg = false)
                  : (isImg = true)
              "
            >
              <img :src="item.picUrl" alt />
            </div>
            <div>
              <div>{{ item.newsTitle }}</div>
              <div>{{ item.sNewsTitle }}</div>
            </div>
      </a>
            <router-link v-else
            class="contNews_title"
            tag="div"
            :to="{
              path: '/scNewsDetail',
              query: {
                newsId: item.newsId,
                newsTitle: item.newsTitle,
                source: item.source,
                createBy: item.createBy,
                newsTitle: item.newsTitle,
                urlAddress: item.urlAddress,
              },
            }"
            
          >
            <div
              class="contentImg"
              v-show="
                item.picUrl == null || item.picUrl == ''
                  ? (isImg = false)
                  : (isImg = true)
              "
            >
              <img :src="item.picUrl" alt />
            </div>
            <div>
              <div>{{ item.newsTitle }}</div>
              <div>{{ item.sNewsTitle }}</div>
            </div>
          </router-link>
          </div>
          
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import { postNewsByPage } from "../../../api/api";
export default {
  data() {
    return {
      scList: [],
      teList: [],
      isImg: false,
      classId: null,
      classCName: "",
    };
  },
  created() {
    //校园动态
    postNewsByPage(49030609377332, 1, 4).then((res) => {
      // console.log(res);
      this.scList = res.list;
    });
    //教育动态
    postNewsByPage(20190085265419, 1, 4).then((res) => {
      // //console.log(res);
      this.teList = res.list;
    });
  },
};
</script>
<style scoped>
.card-container {
  overflow: hidden;
  box-shadow: 0px 0px 20px 0px rgba(0, 91, 176, 0.1);
  width: 100%;
  height: 100%;
  margin-left: 6px;
  position: relative;
}
.titleMore {
  position: absolute;
  top: 10%;
  right: 15px;
  z-index: 1;
  font-size: 12px;
  border-radius: 10px;
}
.ant-btn > .anticon + span,
.ant-btn > span + .anticon {
  margin-left: 0px !important;
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 30px 15px 8px 15px;
}

div /deep/.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
  background-image: url("../../../../static/img/index/lefititle.jpg");
  background-size: 100% 100%;
  margin: 0;
  padding: 30px;
  padding-bottom: 0;
}
div /deep/ .ant-tabs-tab {
  background: none !important;
  border: none !important;
  color: #fff !important;
  font-weight: bold;
}
div /deep/ .ant-tabs-tab-active {
  background: #fff !important;
  border-color: #e8e8e8 !important;
  border-bottom: 1px solid #fff !important;
  color: #1890ff !important;
  font-weight: bold;
}
.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: lightblue;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

.btn {
  position: absolute;
  top: 8%;
  right: 4%;
  background: #1890ff;
  color: #fff;
  padding: 3px 5px;
  border-radius: 11px;
}
.btn:hover {
  cursor: pointer;
}

.contNews_title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3%;
  background-color: #f8f8fa;
  color: #333;
  height: 80px;
  width: 100%;
  padding: 10px 12px;
  padding-left: 0;
}
.contNews_title > div:nth-of-type(1) {
  width: 22%;
  height: 65px;
  text-align: center;
  padding-left: 2%;
}
.contNews_title > div:nth-of-type(2) {
  width: 78%;
  padding: 5px;
  padding-left: 15px;
}
.contNews_title > div:nth-of-type(1) > div:nth-of-type(1) {
  font-size: 22px;
  color: #69686b;
  font-weight: bold;
}
.contNews_title > div:nth-of-type(1) > div:nth-of-type(2) {
  font-size: 12px;
  color: #c5c5c7;
}
.contNews_title > div:nth-of-type(2) > div:nth-of-type(1) {
  width: 88%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.contNews_title > div:nth-of-type(2) > div:nth-of-type(2) {
  width: 95%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  color: #c5c5c7;
  font-size: 12px;
  margin-top: 5px;
}
.contNews_title > div > div {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.contNews_title:hover {
  color: white;
  background: #006cab;
  cursor: pointer;
}
.more {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: #f8f8fa;
  width: 120px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
}
.contentImg > img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/indexComp/smallComp/scDynamic.vue